import { Component } from '@angular/core';

import { CreateNotificationComponent } from './create-notification/create-notification.component';
import { ListNotificationsComponent } from './list-notifications/list-notifications.component';
@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.css',
    imports: [CreateNotificationComponent, ListNotificationsComponent]
})
export class NotificationsComponent {

}
